
import Vue from 'vue'

export default Vue.extend({
  props: ['save', 'saving', 'closeEditDialog'],
})
